import React from 'react';

import { UserContext } from 'src/containers/user';
import { IUserContext } from 'src/containers/user/UserContext';

export default function useUserContext(): IUserContext {
  return React.useContext<IUserContext>(UserContext);
}
